import React, {
  forwardRef, useEffect, useImperativeHandle,
  useState,
} from "react"

export default forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const selectItem = item => {
    props.command({ id: item.id, label: item.name })
  }

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length)
  }

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length)
  }

  const enterHandler = () => {
    selectItem(props.items[selectedIndex])
  }

  useEffect(() => {
    setSelectedIndex(0)
  }, [props.items])

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        downHandler()
        return true
      }

      if (event.key === 'Enter') {
        enterHandler()
        return true
      }

      return false
    },
  }))

  return (
    <div className="suggestions">
      <div className="items">
        {props.items.length
          ? props.items.map((item, index) => (
            <button
              className={`item ${index === selectedIndex ? 'is-selected' : ''}`}
              key={item.id}
              onClick={() => selectItem(item)}
            >
              {item.name}
            </button>
          ))
          : <div className="item">No result</div>
        }
      </div>
    </div>
  )
})
